import { Route } from 'types/route.type';
import SitesOverview from './components/sites-overview';
import { routes as mySupplyPlan } from './features/ofd-1.0/routes';
import { routes as ofd } from './features/ofd-2.0/routes';

export const routes: Route[] = [
  {
    path: '/order-feed/supply-plan/:siteTab?',
    component: SitesOverview,
  },
  ...ofd,
  ...mySupplyPlan,
];
